/* --------------------------------
   画像のParallax表現
-------------------------------- */

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{
    constructor(){
        this.run(document);
    }
    run(d){
        const parallaxElements = d.querySelectorAll("[data-parallax-image]");
        if(parallaxElements.length > 0){
            parallaxElements.forEach((el) => {
                const parallaxImage = el.querySelector("[data-parallax-image-target]");
                if (!parallaxImage) return;

                gsap.set(parallaxImage, { willChange: "transform" });
                gsap.fromTo(parallaxImage, {
                    y: "0",
                },
                {
                    y: () => -el.offsetHeight, 
                    ease: "none", 
                    scrollTrigger: {
                        trigger: el, 
                        start: "top bottom", 
                        end: "bottom top", 
                        scrub: 3, 
                    },
                });
            });
        }
    }
}